import Icon from "@hackclub/icons";

const filters = [
  { key: "all", label: "All Sparks" },
  { key: "our", label: "Our Sparks" },
  { key: "curated", label: "Curated Sparks" },
];

interface Props {
  activeFilter: string;
  onFilterChange: (key: string) => void;
  counts: Record<string, number>;
  onBuildSpark?: () => void;
}

export function SparkBoxSidebar({ activeFilter, onFilterChange, counts, onBuildSpark }: Props) {
  return (
    <div className="sbx-sidebar">
      <div className="sbx-sidebar__label">
        <Icon glyph="bolt" size={12} style={{ color: "var(--sbx-ink-faint)" }} />
        <span>Categories</span>
      </div>

      <div className="sbx-sidebar__list">
        {filters.map((f) => {
          const count = counts[f.key] || 0;
          const isActive = activeFilter === f.key;
          return (
            <button
              key={f.key}
              type="button"
              onClick={() => onFilterChange(f.key)}
              className={`sbx-sidebar__item${isActive ? " sbx-sidebar__item--active" : ""}`}
            >
              <span>{f.label}</span>
              <span className="sbx-sidebar__count">{String(count).padStart(2, "0")}</span>
            </button>
          );
        })}
      </div>

      <div className="sbx-sidebar__idea">
        <Icon glyph="bolt" size={18} style={{ color: "var(--sbx-moss)" }} />
        <p className="sbx-sidebar__idea-title">Have an idea?</p>
        <p className="sbx-sidebar__idea-desc">
          Sketch out a small act of kindness and add it to the shared toolbox.
        </p>
        {/* Opens the "Add a New Spark" popup (AddSparkModal). */}
        <button type="button" className="sbx-sidebar__idea-link" onClick={onBuildSpark}>
          Build a Spark →
        </button>
      </div>
    </div>
  );
}
